import React from 'react';
import PropTypes from 'prop-types';
import requiredIf from 'react-required-if';
import { createComponent } from '@cloudflare/style-container';

var styles = function styles(_ref) {
  var theme = _ref.theme;
  return {
    height: theme.height,
    wordBreak: theme.wordBreak,
    cursor: theme.cursor,
    resize: theme.resize,

    zIndex: theme.zIndex,
    width: theme.width,
    margin: theme.margin,
    padding: theme.padding,
    border: theme.border,
    borderRadius: theme.borderRadius,

    verticalAlign: theme.verticalAlign,
    fontFamily: theme.fontFamily,
    fontSize: theme.fontSize,

    background: theme.background,
    color: theme.color,
    outline: theme.outline,

    transition: theme.transition,

    '&:hover': {
      borderColor: theme['&:hover'].borderColor
    },

    '&:focus': {
      outline: theme['&:hover'].outline,
      outlineOffset: theme['&:hover'].outlineOffset
    }
  };
};

var Textarea = function Textarea(props) {
  return React.createElement('textarea', props);
};
Textarea.displayName = 'Textarea';

Textarea.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  rows: PropTypes.number,
  placeholder: PropTypes.string,
  onChange: requiredIf(PropTypes.func, function (props) {
    return !props.disabled && !props.readOnly;
  }),
  onFocus: PropTypes.func,
  onBlur: PropTypes.func
};

export default createComponent(styles, Textarea, ['name', 'value', 'disabled', 'readOnly', 'placeholder', 'onChange', 'onFocus', 'onBlur', 'rows']);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-textarea/es/Textarea.js
// module id = 1119
// module chunks = 1